import { CompanyCenterPaths } from 'app/configs/routesConfig/companyCenter';
import { TpoCertificationPaths } from 'app/configs/routesConfig/tpoCertification';

import { REQUEST_SOURCE_MODE } from 'constants/api';

export const TOKEN_QUERY_PARAM = 'token';
// DEV-3727: the TPO cert auto-login now carries a refresh token (opaque, so its expiry is passed
// explicitly) alongside the access token, so the AdminPanel host session can refresh instead of showing
// the misleading "RefreshToken is expired" banner.
export const REFRESH_TOKEN_QUERY_PARAM = 'refreshToken';
export const REFRESH_TOKEN_EXPIRES_AT_QUERY_PARAM = 'refreshTokenExpiresAt';
// DEV-4018: the TPO signup handoff sets this flag for a PasskeyWithUsername company so AutoLogin can arm
// the one-time enroll-on-first-login passkey prompt (DEV-3881) — the signup handoff bypasses the Login
// page, which is otherwise the only place that flag is set, so passkey brokers would never be asked.
export const PROMPT_PASSKEY_ENROLL_QUERY_PARAM = 'promptPasskeyEnroll';
export const AUTO_LOGIN_ERROR_MESSAGE = 'Auto-login failed. Please sign in.';
export const AUTO_LOGIN_HOME_PATH = '/';
export const AUTO_LOGIN_BROKER_COMPANY_HOME_PATH = CompanyCenterPaths.companyCenter.path;

/* JWT claim type Accounts uses to identify which authorization scope an access
   token was minted under. AutoLogin reads this claim to decide where to land
   the user (e.g. TPO Signup year-1 cert handoffs land on /tpo-certification
   instead of the default home, which requires broader admin permissions). */
export const SOURCE_MODE_JWT_CLAIM_TYPE = 'http://interfirst.com/identity/claims/SourceMode';

export const AUTO_LOGIN_HOME_PATH_BY_SOURCE_MODE = {
  [REQUEST_SOURCE_MODE.TPO_CERT]: TpoCertificationPaths.tpoCertification.path,
};
